export type PaymentTermsPreset = {
  id: string;
  label: string;
  text: string;
};

/** ແມ່ແບບເງື່ອນໄຂການຊຳລະ — ເລືອກໃສ່ແລ້ວແກ້ໄຂເພີ່ມເຕີມໄດ້ */
export const paymentTermsPresets: PaymentTermsPreset[] = [
  {
    id: "net30",
    label: "Net 30 — ຊຳລະພາຍໃນ 30 ວັນ",
    text: "ຊຳລະພາຍໃນ 30 ວັນ. ການຊຳລະຊັກຊ້າຈະຖືກຄິດດອກເບ້ຍ 1.5% ຕໍ່ເດືອນ.",
  },
  {
    id: "net14",
    label: "Net 14 — ຊຳລະພາຍໃນ 14 ວັນ",
    text: "ຊຳລະພາຍໃນ 14 ວັນ. ການຊຳລະຊັກຊ້າຈະຖືກຄິດດອກເບ້ຍ 1.5% ຕໍ່ເດືອນ.",
  },
  {
    id: "net7",
    label: "Net 7 — ຊຳລະກ່ອນຮັບສິນຄ້າ",
    text: "ຊຳລະພາຍໃນ 7 ວັນ. ຊຳລະກ່ອນຮັບສິນຄ້າ.",
  },
  {
    id: "monthly",
    label: "ຊຳລະລາຍເດືອນ",
    text: "ຊຳລະລາຍເດືອນ. ການຊຳລະຊັກຊ້າຈະຖືກຄິດດອກເບ້ຍ 1.5% ຕໍ່ເດືອນ.",
  },
  {
    id: "prepay_discount",
    label: "ລາຍເດືອນ ຫຼື ຈ່າຍລ່ວງໜ້າຫຼຸດ 5%",
    text: "ຊຳລະລາຍເດືອນ ຫຼື ຊຳລະທັງໝົດລ່ວງໜ້າໄດ້ສ່ວນຫຼຸດ 5%.",
  },
  {
    id: "milestone",
    label: "ໂຄງງວດ — ມັດຈຳ / ກາງ / ປິດງານ",
    text: "ມັດຈຳ 30% ເມື່ອເຊັນສັນຍາ / ງວດກາງ 40% ເມື່ອສົ່ງມອບກາງ / ປິດງານ 30% ເມື່ອສຳເລັດ.",
  },
];

export const paymentTermsPresetSelectOptions = paymentTermsPresets.map((p) => ({
  value: p.id,
  label: p.label,
}));

export function findPaymentTermsPresetId(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) return "";
  return paymentTermsPresets.find((p) => p.text === trimmed)?.id ?? "";
}

export function getPaymentTermsPresetText(id: string): string | undefined {
  return paymentTermsPresets.find((p) => p.id === id)?.text;
}
